import { useApolloClient } from "@apollo/client"
import { GestionarProductoDetalleDtSourceImplGql } from "../../data/dataSources/GestionarProductoDetalleDtSourceImplGql";
import { GestionarProductoDetalleRepositoryImpl } from "../../data/repositories/GestionarProductoDetalleRepositoryImpl";
import { DeleteProductoDetalleParams, UpdateProductoDetalleParams } from "../../utils/params/ProductoDetalleParams";
import { UpdateProductoDetalleUseCase } from "../../business/useCases/UpdateProductoDetalleUseCase";
import { toast } from "lib.front/dist";
import { AddProductoDetalleUseCase } from "../../business/useCases/AddProductoDetalleUseCase";
import { GetAllProductoDetalleUseCase } from "../../business/useCases/GetAllProductoDetalleUseCase";
import { DeleteProductoDetalleUseCase } from "../../business/useCases/DeleteProductoDetalleUseCase";

export const useGestionarProductoDetalle = () => {
    const apolloClient = useApolloClient();
    const dataSource = new GestionarProductoDetalleDtSourceImplGql(apolloClient);
    const repository = new GestionarProductoDetalleRepositoryImpl(dataSource);

    const getAllProductoDetalle = async () => {
        const useCase = new GetAllProductoDetalleUseCase(repository);
        try {
            const recurso = await useCase.call();
            if (recurso.isError()) {
                toast.showError(recurso.toString());
                return undefined;
            }
            return recurso.data;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        }
    }

    const addProductoDetalle = async (input: UpdateProductoDetalleParams) => {
        const useCase = new AddProductoDetalleUseCase(repository);
        try {
            const recurso = await useCase.call(input);
            if (recurso.isError()) {
                toast.showError(recurso.toString());
                return undefined;
            }
            return recurso.data;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        }
    }

    const updateProductoDetalle = async (input: UpdateProductoDetalleParams) => {
        const useCase = new UpdateProductoDetalleUseCase(repository);
        try {
            const recurso = await useCase.call(input);
            if (recurso.isError()) {
                toast.showError(recurso.toString());
                return undefined;
            }
            return recurso.data;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        }
    }

    const deleteProductoDetalle = async (input: DeleteProductoDetalleParams) => {
        const useCase = new DeleteProductoDetalleUseCase(repository);
        try {
            const recurso = await useCase.call(input);
            if (recurso.isError()) {
                toast.showError(recurso.toString());
                return undefined;
            }
            return recurso.data;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        }
    }
    return { getAllProductoDetalle, addProductoDetalle, updateProductoDetalle, deleteProductoDetalle }
}